<template>
  <div v-if="contractId && jwt">
    <div class="safetyPadding">
      <dx-scip-sales
        v-if="product.key && product.variantKey && product.versionNumber"
        :product-key="product.key"
        :variant-key="product.variantKey"
        :version-number="product.versionNumber"
        :contract-id="contractId"
        :auth-token="jwt"
        channel="employee"
      />

      <div v-else class="content-bg-color">
        <div class="container-fluid content-pad">
          <dx-products is-iframe />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="content-bg-color">
    <div class="container-fluid content-pad">
      <dx-single-notification type="warning">
        <span slot="headline">
          {{ $t('notifications.error.headline') }}
        </span>
        <div slot="message" class="text-center py-2">
          {{ $t('loginPage.errors.sessionExpired') }}
        </div>
      </dx-single-notification>
    </div>
  </div>
</template>

<script>
import DxScipSales from '~/components/DX-ScipSales'
import DxProducts from '~/domains/partnerPortal/components/DX-Products'
import DxSingleNotification from '~/components/DX-Notifications/SingleNotification'

export default {
  name: 'BrokerOfferScipSales',
  components: {
    DxScipSales,
    DxProducts,
    DxSingleNotification,
  },
  layout: 'empty',
  meta: {
    isPublic: true,
  },
  nuxtI18n: {
    paths: {
      de: '/antragsstrecke-iframe/',
      fr: '/formulaire-de-demande-iframe/',
    },
  },

  computed: {
    contractId() {
      return Number(this.$route.query.contractid) || null
    },

    jwt() {
      return this.$route.query.jwt || null
    },

    product() {
      const key = this.$route.query.key || null
      const variantKey = this.$route.query.variantKey || null
      const versionNumber = Number(this.$route.query.versionNumber) || 1

      return {
        key,
        variantKey,
        versionNumber,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.safetyPadding {
  padding-bottom: rem(200);
  background: #f7f9fc;
}
</style>
